import { useContext } from 'react'
import { R } from '@utils/currency'

import { RiskProductsContext } from '../../context'

const toArray = (value) => {
  if (Array.isArray(value)) return value
  if (value != null) return [value]
  return []
}

export const buildInitialValues = () => {
  const { state } = useContext(RiskProductsContext)
  const { riskProduct, formRiskProductType } = state
  const initialValues = {
    name: riskProduct.name,
    value: R(riskProduct.value).value,
    monthly_contribution: R(riskProduct.monthly_contribution).value,
    product_type: formRiskProductType,
    contract_number: riskProduct.contract_number,
    service_provider_id: riskProduct.service_provider_id,
    owners: toArray(riskProduct.owners),
    payers: toArray(riskProduct.payers),
    beneficiaries: toArray(riskProduct.beneficiaries),
  }
  return initialValues
}
